import { localStorageEnabled } from '../lib/util'

import { HarvestIdApi } from './api'

export const ACCESS_TOKEN_STORAGE_KEY = 'access_token'
export const ACCOUNT_ID_STORAGE_KEY = 'account_id'

export const accessToken =
  localStorageEnabled && localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY)

export const currentAccountId =
  localStorageEnabled && localStorage.getItem(ACCOUNT_ID_STORAGE_KEY)

export const isAuthenticated = () =>
  localStorageEnabled &&
  !!localStorage.getItem('access_token') &&
  !!localStorage.getItem('account_id')

export function storeCredentials(token, accountId, viaSaml = null) {
  localStorage.setItem('account_id', accountId)
  localStorage.setItem('access_token', token)
  localStorage.setItem('via_saml', viaSaml)
  return true
}

export function removeCredentials() {
  if (!localStorageEnabled) return
  localStorage.removeItem('access_token')
  localStorage.removeItem('account_id')
}

export async function signOut() {
  if (!accessToken || !currentAccountId) return

  const client = new HarvestIdApi(accessToken, currentAccountId)
  await client.delete('/session')

  removeCredentials()

  window.location.reload()
}
